/* eslint-disable consistent-return */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-async-promise-executor */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-use-before-define */
/* eslint-disable no-loop-func */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import { studies } from '@ohif/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppStyled, BoxColumns } from '../styled/AppStyled';
import Header from '../Header/Header';
import Explorer from '../SeriesExplorer/Explorer';
import Viewer from './Viewer';
import store from '../../../store/store';
import LayoutElement from '../../../model/entity/LayoutElement';
import { getAvailableRenderers, isRenderableSeries } from '../../../model/getAvailableRenderers';
import { setPatient, addStudy, setMainStudyId } from '../../../actions/PatientActions';
import { setCurrentTool, setLayoutElements, setLayoutGrid, setSelectedView, setIs3DModeEnabled, setIsMPRModeEnabled } from '../../../actions/LayoutActions';
import { setWaveformLayout, setWaveformViewIndex, setWaveformScaleFactor, setWaveformTimeFactor } from '../../../actions/WaveformActions';
import useServerConfig, { getAvailableServers } from '../../../util/useServerConfig';
import {
  parsePatientFromStudy,
  fetchAllPatientMetadata,
  getStudyById,
  removeDuplicateSeries,
  loadNextSeriesOhifMetadata,
} from '../../../util/studiesManager';
import { Error } from '../../Error';
import { MessageWrapper } from '../Common/MessageWrapper';
import { CaptureDownloadDialog } from '../Common/CaptureDownloadDialog';
import { cryptDecode } from '../../../auth/service/cryptDecode';
import { SearchByPatientId } from './SearchByPatientId';
import { SearchByAccessionNumber } from './SearchByAccessionNumber';
import { arraysAreEqual } from '../../../model/ArrayUtils';
import { PatientHistory } from '../Common/PatientDatasource/PatientHistory';
import { ViewerOverlayContainer } from '../Common/styled/PatientHistory';
import DemoVersion from '../Common/DemoVersion';
import { getSelectedPacsConfig } from '../../../util/pacsSelectorConfig';
import { getChildLayoutKey, getChildViewportState } from '../../../util/isChildViewport';
import { cameraOptionsMpr, cameraOptionsVr, mprDefault, vrDefault } from './renderer/Image3d/volumeInitOptions';
import { RENDER_TYPE_3D } from '../../../model/factoryRenderers';
import {
  closeCrossWindow2dReferenceLines,
  getCrossWindowWindowId,
  initializeCrossWindow2dReferenceLines,
  setCrossWindowSelectedTool,
} from './crossWindow2dReferenceLines';
import {
  captureScreenShot,
  captureScreenShot3D,
  captureScreenShotECG,
  downloadScreenShot,
  downloadScreenShot3D,
  downloadScreenShotECG,
  screenShot,
  screenShot3D,
  screenShotECG,
} from '../../../util/takeScreenShot';
import toolNames from '../Header/Toolbar/toolNames';

const versionPackage = require('../../../../package.json');
const isDemoVersion = process.env.DEMO_VERSION === 'yes';

export const displayFirstSeries = (study, StudyInstanceUID, childLayout) => {
  store.dispatch(setIs3DModeEnabled(false));
  store.dispatch(setIsMPRModeEnabled(false));
  store.dispatch(setLayoutGrid(1, 1));
  store.dispatch(setSelectedView(0));

  if (childLayout?.elements?.length) {
    const { patient } = store.getState();
    const layoutElements = childLayout.elements.map((element) => {
      if (!element) return null;
      const seriesStudy = (patient.studies || []).find((item) => item.StudyInstanceUID === element.studyUID);
      if (!seriesStudy) return null;
      const series = (seriesStudy.series || []).find((item) => item.SeriesInstanceUID === element.seriesUID);
      const availableRenderers = series?.instances?.length
        ? getAvailableRenderers(series.instances)
        : element.availableRenderers?.length
          ? element.availableRenderers
          : element.renderType ? [element.renderType] : [];
      const layoutElement = new LayoutElement();
      layoutElement.StudyInstanceUID = element.studyUID;
      layoutElement.SeriesInstanceUID = element.seriesUID;
      layoutElement.renderType = element.mode === 'mpr' || element.mode === 'vr'
        ? RENDER_TYPE_3D
        : availableRenderers.includes(element.renderType) ? element.renderType : availableRenderers[0];
      layoutElement.availableRenderers = availableRenderers;

      if (element.mode === 'mpr') {
        layoutElement.initOptions = cameraOptionsMpr.find((option) => option.viewType.camera === element.camera) || mprDefault;
      } else if (element.mode === 'vr') {
        layoutElement.initOptions = cameraOptionsVr.find((option) => option.viewType.camera === element.camera) || vrDefault;
      }

      return layoutElement;
    });

    store.dispatch(setLayoutGrid(childLayout.columns, childLayout.rows));
    store.dispatch(setSelectedView(childLayout.selectedViewIndex || 0));
    store.dispatch(setIs3DModeEnabled(childLayout.mode === '3d'));
    store.dispatch(setIsMPRModeEnabled(childLayout.mode === 'mpr'));
    store.dispatch(setCurrentTool(childLayout.currentTool || 'Wwwc'));
    store.dispatch(setLayoutElements(layoutElements));

    if (childLayout.waveform?.layout) {
      store.dispatch(setWaveformLayout(childLayout.waveform.layout));
      store.dispatch(setWaveformViewIndex(childLayout.waveform.viewIndex || 0));
      store.dispatch(setWaveformScaleFactor(childLayout.waveform.scaleFactor || 1));
      store.dispatch(setWaveformTimeFactor(childLayout.waveform.timeFactor || 1));
    }
    return;
  }

  const layoutElement = new LayoutElement();
  layoutElement.StudyInstanceUID = StudyInstanceUID;
  const firstSeries = study.series[0];

  if (firstSeries) {
    if (isRenderableSeries(firstSeries)) {
      const availableRenderers = getAvailableRenderers(firstSeries.instances);
      const renderType = availableRenderers[0];
      layoutElement.SeriesInstanceUID = firstSeries.SeriesInstanceUID;
      layoutElement.renderType = renderType;
      layoutElement.availableRenderers = availableRenderers;

    }
  }

  store.dispatch(setLayoutElements([layoutElement]));
};

/**
 * @param a {object}
 * @param b {object}
 * @returns {boolean}
 */
const matchSeriesAndImageType = (a, b) => arraysAreEqual(a.ImageType, b.ImageType)
  && a.SeriesInstanceUID === b.SeriesInstanceUID;

/**
 * @param elem {object[]}
 * @returns {string[]}
 */
const getSeriesInstanceUIDs = (elem) => elem.map((s) => s.SeriesInstanceUID).filter((uid) => uid !== undefined);

/**
 * @param instance {object}
 * @returns {{SeriesInstanceUID: string, ImageType: string[], instances: Set<object>}}
 */
const generateInstanceGroupItem = (instance) => ({
  SeriesInstanceUID: instance.SeriesInstanceUID,
  ImageType: instance.ImageType,
  instances: new Set([instance]),
});

const getSeriesInstanceReport = (study) => {
  const instancesMap = new Map();
  const instancesGrouped = new Set();

  const { series } = study;

  series.forEach((s) => {
    s.instances.forEach((i) => {
      instancesMap.set(i.metadata.SOPInstanceUID, {
        SeriesInstanceUID: s.SeriesInstanceUID,
        SOPInstanceUID: i.metadata.SOPInstanceUID,
        ImageType: i.metadata.ImageType,
      });
    });
  });

  const findInstanceGroupItem = (instance) => instancesGrouped.find((item) => matchSeriesAndImageType(item, instance));

  instancesMap.forEach((instance) => {
    const seriesInstanceGroup = findInstanceGroupItem(instance);
    if (!seriesInstanceGroup) return instancesGrouped.add(generateInstanceGroupItem(instance));
    seriesInstanceGroup.instances.add(instance);
  });

  return instancesGrouped;
};

/**
 * @param study {object}
 * @returns {object}
 */
const studySeriesParsedByImageType = (study) => {
  const modality3D = ['CT', 'MR', 'PET'];
  const { series } = study;
  const seriesInstanceReport = getSeriesInstanceReport(study);

  const seriesNumbers = {
    list: series.map((s) => s.SeriesNumber),
    offset: 750,
  };

  const generateSeriesNumber = () => {
    while (seriesNumbers.list.includes(seriesNumbers.offset.toString())) {
      seriesNumbers.offset += 1;
    }
    return seriesNumbers.offset.toString();
  };

  const groupSerieByImageType = (serie, group, index) => {
    let SeriesInstanceUID = serie.SeriesInstanceUID;
    let SeriesNumber = serie.SeriesNumber;

    if (index > 0) {
      SeriesInstanceUID = `${serie.SeriesInstanceUID}:${index}`;
      SeriesNumber = generateSeriesNumber();
      seriesNumbers.list.push(SeriesNumber);
    }
    const instances = [...group.instances]
      .map((instance) => serie.instances
        .find((i) => i.metadata.SOPInstanceUID === instance.SOPInstanceUID));

    return {
      ...serie,
      SeriesInstanceUID,
      SeriesNumber,
      instances,
    };
  };

  const groupSeriesByImageType = (serie) => {
    if (!modality3D.includes(serie.Modality)) return [serie];

    const seriesInstanceGroups = seriesInstanceReport
      .filter((item) => item.SeriesInstanceUID === serie.SeriesInstanceUID);

    return [...seriesInstanceGroups].map((group, index) => groupSerieByImageType(serie, group, index));
  };

  const seriesArray = [];
  const seriesMap = new Map();

  series.forEach((serie) => {
    if (!getSeriesInstanceUIDs(seriesArray).includes(serie.SeriesInstanceUID)) {
      seriesArray.push(...groupSeriesByImageType(serie));
    }
  });

  seriesArray.forEach((serie) => seriesMap.set(serie.SeriesInstanceUID, serie));

  return { ...study, series: seriesArray, seriesMap };
};

let cancelCallback = [];

export default (props) => {
  const childLayoutKey = getChildLayoutKey();
  const isChildViewport = Boolean(childLayoutKey);
  const [childLayout] = useState(() => getChildViewportState());
  const childSyncChannel = childLayout?.syncChannel;

  useEffect(() => {
    if (!childLayoutKey) return;
    try {
      const storageKey = `childViewportState:${childLayoutKey}`;
      window.localStorage.removeItem(storageKey);
    } catch (storageError) {
      // The child layout is already in component state; cleanup is best effort.
    }
  }, []);

  const { t } = useTranslation();
  // eslint-disable-next-line react/destructuring-assignment
  const {
    StudyInstanceUID,
    AccessionNumber,
    PatientId,
    SeriesInstanceUIDs,
  } = (props && props.match && props.match.params && props.match.params) || props;
  const [fetchComplete, setFetchComplete] = useState(false);
  const server = useServerConfig({ lazy: false });
  const selectedSeriesInstanceUIDs = SeriesInstanceUIDs
    ? SeriesInstanceUIDs.split(',').filter(Boolean)
    : null;
  const showExplorer = useSelector((state) => state.layout.showExplorer);
  const showHistory = useSelector((state) => state.layout.showHistory);
  const config = useSelector((state) => state.config);
  const [error, setError] = useState(null);
  const [renderViewer, setRenderViewer] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(Boolean(document.fullscreenElement));
  const [showChildCaptureDownload, setShowChildCaptureDownload] = useState(false);
  const [childCaptureType, setChildCaptureType] = useState('2d');

  useEffect(() => {
    if (!isChildViewport || !childSyncChannel) return undefined;
    initializeCrossWindow2dReferenceLines(childSyncChannel, false);
    const handleParentToolChange = (event) => {
      if (event.detail?.tool) store.dispatch(setCurrentTool(event.detail.tool));
    };
    window.addEventListener('viewer-parent-selected-tool', handleParentToolChange);
    return () => {
      window.removeEventListener('viewer-parent-selected-tool', handleParentToolChange);
      closeCrossWindow2dReferenceLines();
    };
  }, []);

  useEffect(() => {
    if (!isChildViewport) return undefined;
    const handleActiveViewportCommand = (event) => {
      const { windowId, viewIndex, toolName } = event.detail || {};
      if (windowId !== getCrossWindowWindowId() || !Number.isInteger(viewIndex)) return;
      if (toolName !== toolNames.COPY_CAPTURE && toolName !== toolNames.DOWNLOAD_CAPTURE) return;

      const { layout } = store.getState();
      const layoutElement = layout.elements[viewIndex];
      const captureType = layoutElement?.renderType === 'waveform'
        ? 'ecg'
        : layout.is3DModeEnabled || layout.isMPRModeEnabled || layoutElement?.renderType === '3d'
          ? '3d'
          : '2d';

      if (toolName === toolNames.COPY_CAPTURE) {
        if (captureType === 'ecg') screenShotECG(t, viewIndex);
        else if (captureType === '3d') screenShot3D(t);
        else screenShot(t);
        return;
      }

      setChildCaptureType(captureType);
      setShowChildCaptureDownload(true);
    };

    window.addEventListener('viewer-active-viewport-command', handleActiveViewportCommand);
    return () => window.removeEventListener('viewer-active-viewport-command', handleActiveViewportCommand);
  }, [isChildViewport, t]);

  useEffect(() => {
    if (isChildViewport) return undefined;
    let previousTool = store.getState().layout.currentTool;
    return store.subscribe(() => {
      const currentTool = store.getState().layout.currentTool;
      if (currentTool !== previousTool) {
        previousTool = currentTool;
        setCrossWindowSelectedTool(currentTool);
      }
    });
  }, []);

  useEffect(() => {
    const handleActiveViewportChange = (event) => {
      const { windowId, viewIndex } = event.detail || {};
      if (windowId === getCrossWindowWindowId() && Number.isInteger(viewIndex)) {
        store.dispatch(setSelectedView(viewIndex));
      }
    };
    window.addEventListener('viewer-active-viewport-changed', handleActiveViewportChange);
    return () => {
      window.removeEventListener('viewer-active-viewport-changed', handleActiveViewportChange);
    };
  }, []);

  useEffect(() => {
    const handleFullscreenChange = () => setIsFullscreen(Boolean(document.fullscreenElement));
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', handleFullscreenChange);
  }, []);

  const enterFullscreen = () => {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen({ navigationUI: 'hide' }).catch(() => {});
    }
  };

  let mainStudyInstanceUID = StudyInstanceUID;

  const { WITH_HIBA_URL_ENCRYPTED, HIBA_SALT, FETCH_SERIES_BY_ACCESSION_NUMBER } = config;
  const accessionNumberToFetch = WITH_HIBA_URL_ENCRYPTED ? cryptDecode(AccessionNumber, HIBA_SALT) : AccessionNumber;
  const isStudyParseableByImageType = () => {
    const selectedPacs = getSelectedPacsConfig(config);
    const thumbnailEndpoint = selectedPacs?.thumbnailUrl || config.WADO_RS_THUMBNAIL_ENDPOINT;
    if (!thumbnailEndpoint) return true;
    return !thumbnailEndpoint.match(/^(instance|proxy):(.*)$/);
  };

  useEffect(() => {
    if (error !== null) return;
    let canceled = false;

    if (SeriesInstanceUIDs !== undefined && !selectedSeriesInstanceUIDs?.length) {
      setError('error.notFound');
      return undefined;
    }

    store.dispatch(setPatient(null));
    const availableServers = getAvailableServers(server, true);

    console.log(`%cversion: ${versionPackage.version.replace('-', '.')}`, 'padding: 4px; font-weight: 700; color: white; background-color: #044492;');
    let mainStudy;
    let promises = [];

    const fetchStudyPromise = ({ pServer }) => new Promise(async (resolve) => {
      let study;
      let finished;

      cancelCallback.push(() => {
        if (!finished) {
          canceled = true;
          resolve(false);
        }
      });

      // GET STUDY
      try {
        studies.deleteStudyMetadataPromise(mainStudyInstanceUID);
        study = await studies.retrieveStudyMetadata(
          pServer,
          mainStudyInstanceUID,
          SeriesInstanceUIDs !== undefined
            ? { seriesInstanceUID: selectedSeriesInstanceUIDs.join(',') }
            : undefined
        );
      } catch (err) {
        console.error('*** no study data via studyInstanceUID at: ', pServer.qidoRoot, err);
        resolve(false);
      }

      if (!canceled && study) {
        // Load the remaining series in the background. The first series is
        // already available, so do not delay thumbnail and pixel-data loads.
        loadNextSeriesOhifMetadata(study, pServer).catch((loadError) => {
          console.error('Unable to load the remaining study metadata.', loadError);
        });

        if (isStudyParseableByImageType()) {
          study = studySeriesParsedByImageType(study);
        }

        if (!childLayout && study && study.StudyInstanceUID) {
          displayFirstSeries(study, study.StudyInstanceUID);
        }

        if (mainStudy) {
          const tempSeries = study.series;
          const series = mainStudy.series;
          const mergedSeries = [...series, ...tempSeries];
          const seriesNew = removeDuplicateSeries(mergedSeries);
          const tempSeriesMap = study.seriesMap;
          mainStudy.series.forEach((serie) => {
            tempSeriesMap[serie.SeriesInstanceUID] = serie;
          });
          mainStudy = { ...mainStudy, seriesMap: tempSeriesMap, series: seriesNew };
        } else {
          mainStudy = { ...study, servers: availableServers };
        }

        store.dispatch(addStudy(mainStudy));
        store.dispatch(setMainStudyId(mainStudy.StudyInstanceUID));

        finished = true;
        resolve(true);
      }
    });

    const checkPatientHistory = () => {
      const patient = parsePatientFromStudy(mainStudy);

      store.dispatch(setPatient(patient));

      return fetchAllPatientMetadata(patient.PatientID, availableServers);
    };

    const loadChildLayoutStudies = async () => {
      if (!Array.isArray(childLayout?.elements)) return;

      const studyUIDs = [...new Set(childLayout.elements
        .filter(Boolean)
        .map((element) => element.studyUID)
        .filter((studyUID) => studyUID && studyUID !== mainStudyInstanceUID))];

      await Promise.all(studyUIDs.map(async (studyUID) => {
        try {
          let childStudy = await getStudyById(studyUID, availableServers);
          if (!childStudy) return;
          if (isStudyParseableByImageType()) {
            childStudy = studySeriesParsedByImageType(childStudy);
          }
          store.dispatch(addStudy(childStudy));
        } catch (loadError) {
          console.error(`Unable to load study ${studyUID} for the expanded viewport grid.`, loadError);
        }
      }));
    };

    const getStudyInstanceUIDByAccessionNumber = async () => {
      let studyInstanceUIDByAN;

      for (let serverIndex = 0; serverIndex < availableServers.length; serverIndex++) {
        const availableServer = availableServers[serverIndex];

        if (FETCH_SERIES_BY_ACCESSION_NUMBER) {
          availableServer.seriesExtraFilters = { AccessionNumber: accessionNumberToFetch }; // parameter seriesExtraFilters is a patch inside ohif_core to permit this functionality, needs a full refactor
        }

        studyInstanceUIDByAN = await SearchByAccessionNumber({
          AccessionNumber: accessionNumberToFetch,
          server: availableServer,
        });

        if (studyInstanceUIDByAN) break;
      }
      return studyInstanceUIDByAN;
    };

    const searchByStudyInstanceUID = async () => {
      // ACCESSION NUMBER
      if (accessionNumberToFetch !== undefined) {
        mainStudyInstanceUID = await getStudyInstanceUIDByAccessionNumber();
      }

      for (let index = 0; index < availableServers.length; index++) {
        let pServer = availableServers[index];
        promises.push(fetchStudyPromise({ index, pServer, accessionNumberToFetch, StudyInstanceUID }));
      }

      Promise.all(promises).then((values) => {
        const isError = !values.find((value) => value);
        if (isError) {
          setError('error.notFound');
        } else {
          checkPatientHistory().then(async () => {
            if (childLayout) {
              await loadChildLayoutStudies();
              const loadedMainStudy = store.getState().patient.studies
                .find((study) => study.StudyInstanceUID === mainStudyInstanceUID) || mainStudy;
              displayFirstSeries(loadedMainStudy, mainStudyInstanceUID, childLayout);
            }
            setFetchComplete(true);
            // patch to make thumbnails calls first and then render instances. change when loader refactor is done
            setTimeout(() => {
              setRenderViewer(true);
            }, 100);
          });
        }
      });
    };

    // PATIENT ID
    if (PatientId !== undefined) {
      SearchByPatientId({
        PatientId,
        availableServers,
        setFetchComplete,
        setRenderViewer,
        setError,
      }).then();
    } else {
      searchByStudyInstanceUID().then();
    }

    return () => {
      for (let i = 0; i < cancelCallback.length; i++) {
        cancelCallback[i]();
      }
      cancelCallback = [];
    };
  }, []);

  return (
    <>
      {!error ? (
        <AppStyled>
          {isChildViewport && (
            <CaptureDownloadDialog
              open={showChildCaptureDownload}
              onClose={() => setShowChildCaptureDownload(false)}
              getCapture={childCaptureType === 'ecg'
                ? captureScreenShotECG
                : childCaptureType === '3d'
                  ? captureScreenShot3D
                  : captureScreenShot}
              onSubmit={childCaptureType === 'ecg'
                ? downloadScreenShotECG
                : childCaptureType === '3d'
                  ? downloadScreenShot3D
                  : downloadScreenShot}
            />
          )}
          {isChildViewport && !isFullscreen && (
            <button
              type="button"
              aria-label={t('toolbar.fullscreen')}
              title={t('toolbar.fullscreen')}
              onClick={enterFullscreen}
              style={{
                position: 'fixed',
                top: 8,
                right: 8,
                zIndex: 100000,
                padding: '5px 8px',
                border: '1px solid rgba(255, 255, 255, 0.6)',
                borderRadius: 4,
                color: '#fff',
                background: 'rgba(0, 0, 0, 0.65)',
                cursor: 'pointer',
              }}
            >
              {t('toolbar.fullscreen')}
            </button>
          )}
          {!isChildViewport && <Header fetchComplete={fetchComplete} className="head" />}
          <BoxColumns className="box">
            {!isChildViewport && <Explorer fetchComplete={fetchComplete} showExplorer={showExplorer} />}
            { renderViewer
              ? (
                <ViewerOverlayContainer>
                  <Viewer className="view" />
                  {!isChildViewport && showHistory && <PatientHistory />}
                  {!isChildViewport && isDemoVersion && <DemoVersion />}
                </ViewerOverlayContainer>
              )
              : <MessageWrapper>{t('loading.study')}</MessageWrapper>}
          </BoxColumns>
        </AppStyled>
      ) : (
        getError({ entryParam: { AccessionNumber, StudyInstanceUID, PatientId }, props, t, error })
      )}
    </>
  );
};

const getError = ({ entryParam, props, t, error }) => {
  const param = Object.keys(entryParam).find((key) => entryParam[key] !== undefined);
  switch (param) {
    case 'AccessionNumber':
      return <Error message={`${t(error)} \n AccesionNumber: ${entryParam.AccessionNumber}`} showBackButton history={props.history} />;
    case 'StudyInstanceUID':
      return <Error message={`${t(error)}  \n StudyInstanceUID: ${entryParam.StudyInstanceUID}`} showBackButton history={props.history} />;
    case 'PatientId':
      return <Error message={`${t(error)}  \n PatientId: ${entryParam.StudyInstanceUID}`} showBackButton history={props.history} />;
    default:
      return <Error message={`${t(error)}`} showBackButton history={props.history} />;
  }
};
